import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { env } from '../../../../node_modules/@types/shelljs';

@Injectable()
export class SharedService {
  UserDataEvent: EventEmitter<any> = new EventEmitter();

  hostUrl: any = environment.API_BASE_URL;
  urlToFetchUserAccountDetails: any = this.hostUrl + 'v1/user/';
  constructor(private _http: HttpClient) {
    let user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    if (user) {
      //this.getUserInfo(user.id);
    }
  }
  getUserInfo(id) {
    return this._http
      .get(this.urlToFetchUserAccountDetails + id + '?getAccounts=true')
      .map((res: Response) => res)
      .subscribe((response: any) => {
        if (response.success) {
          this.UserDataEvent.emit(response);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/common/shared.service.ts